import { Dispatch, SetStateAction, createContext, useState } from "react";

import type {
    FinanceCalculationResponse,
    GetFinanceCalculationParams,
} from "services/motorpoint/finance";
import {
    LookupVehicleCapDataError,
    LookupVehicleCapDataParams,
    LookupVehicleCapDataResponse,
} from "services/motorpoint/partExchange";
import { FinanceSubmitEventData } from "utils/generateGtmFinanceSubmitEvent";

import useFinanceData from "./useFinanceData";
import useVehicleCapData from "./useVehicleCapData";

type FinanceDataContextProps = {
    financeData: FinanceCalculationResponse | null;
    financeError: string | null;
    setFinanceData: (data: FinanceCalculationResponse) => void;
    getFinanceData: (
        params: GetFinanceCalculationParams,
        event?: FinanceSubmitEventData
    ) => Promise<FinanceCalculationResponse | null>;

    vehicleCapData: LookupVehicleCapDataResponse | null;
    vehicleCapDataError: string | null;
    setVehicleCapData: (data: LookupVehicleCapDataResponse | null) => void;
    getVehicleCapData: (
        params: LookupVehicleCapDataParams
    ) => Promise<LookupVehicleCapDataResponse | LookupVehicleCapDataError | null>;
    resetVehicleCapData: () => void;
    isHpShowing: boolean;
    setIsHpShowing: Dispatch<SetStateAction<boolean>>;
    depositFromFinanceWidget: number | undefined;
    setDepositFromFinanceWidget: Dispatch<SetStateAction<undefined | number>>;
    milageSelection: number | undefined;
    setMilageSelection: Dispatch<SetStateAction<undefined | number>>;
} | null;

type FinanceDataProviderProps = {
    children: React.ReactNode;
};

export const FinanceDataContext = createContext<FinanceDataContextProps>(null);

const FinanceDataProvider = ({ children }: FinanceDataProviderProps) => {
    const [isHpShowing, setIsHpShowing] = useState(false);
    const [milageSelection, setMilageSelection] = useState<number | undefined>(undefined);
    const [depositFromFinanceWidget, setDepositFromFinanceWidget] = useState<number | undefined>(
        undefined
    );

    const { financeError, financeData, setFinanceData, getFinanceData } = useFinanceData();
    const {
        vehicleCapDataError,
        vehicleCapData,
        setVehicleCapData,
        getVehicleCapData,
        resetVehicleCapData,
    } = useVehicleCapData();
    return (
        <FinanceDataContext.Provider
            value={{
                financeError,
                financeData,
                setFinanceData,
                getFinanceData,

                vehicleCapData,
                vehicleCapDataError,
                setVehicleCapData,
                getVehicleCapData,
                resetVehicleCapData,

                isHpShowing,
                setIsHpShowing,

                depositFromFinanceWidget,
                setDepositFromFinanceWidget,

                milageSelection,
                setMilageSelection,
            }}
        >
            {children}
        </FinanceDataContext.Provider>
    );
};

export default FinanceDataProvider;
